<template>
  <div>
    <v-menu v-model="menu" :close-on-content-click="false" offset-y>
      <template v-slot:activator="{ on }">
        <div class="testata" v-on="on">
          <div class="font-weight-medium">
            <v-icon size="15" class="mr-1">mdi-calendar</v-icon>{{ giorno }}
          </div>
          <div class="grey--text text-caption">
            <v-icon size="14" class="mr-1">mdi-cart</v-icon>{{ cc }}
          </div>
          <div v-if="consegna.id_ordine_creato" class="blue--text text-caption">
            <v-icon size="14" color="blue" class="mr-1">mdi-clipboard</v-icon>
            <span v-if="numero_ordine">#{{ numero_ordine }}</span>
            <span v-else>ordine</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-if="conteggiato"
                  size="14"
                  color="green"
                  class="ml-1"
                  v-on="on"
                >
                  mdi-check-decagram
                </v-icon>
              </template>
              <span>Ordine conteggiato</span>
            </v-tooltip>
          </div>
        </div>
      </template>

      <v-list dense>
        <!-- Cambia data -->
        <v-menu :close-on-content-click="false" offset-x>
          <template v-slot:activator="{ on }">
            <v-list-item v-on="on">
              <v-list-item-icon><v-icon>mdi-calendar</v-icon></v-list-item-icon>
              <v-list-item-title>Cambia data</v-list-item-title>
            </v-list-item>
          </template>
          <v-date-picker
            :value="data_iso"
            locale="it-it"
            first-day-of-week="1"
            @change="cambia_data"
          />
        </v-menu>

        <!-- Stampa -->
        <v-list-item :disabled="occupato" @click="stampa">
          <v-list-item-icon><v-icon color="purple">mdi-printer</v-icon></v-list-item-icon>
          <v-list-item-title>Stampa</v-list-item-title>
        </v-list-item>

        <!-- Conteggio dell'ordine, quando c'è stato -->
        <v-list-item v-if="conteggiato" @click="apri_conteggio">
          <v-list-item-icon>
            <v-icon color="green">mdi-clipboard-check</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Conteggio</v-list-item-title>
        </v-list-item>

        <!-- Riempi rimanenza -->
        <v-list-item
          v-if="!consegna.id_ordine_creato"
          :disabled="occupato"
          @click="riempi_rimanenza"
        >
          <v-list-item-icon>
            <v-progress-circular v-if="in_corso === 'rimanenza'" indeterminate size="20" width="2" color="green" />
            <v-icon v-else color="green">mdi-package-down</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Riempi rimanenza</v-list-item-title>
        </v-list-item>

        <!-- Crea ordine -->
        <v-list-item
          v-if="!consegna.id_ordine_creato"
          :disabled="occupato"
          @click="crea_ordine"
        >
          <v-list-item-icon>
            <v-progress-circular v-if="in_corso === 'ordine'" indeterminate size="20" width="2" color="blue" />
            <v-icon v-else color="blue">mdi-clipboard-text-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Crea ordine</v-list-item-title>
        </v-list-item>

        <v-divider />

        <!-- Elimina -->
        <v-list-item :disabled="occupato" @click="conferma_elimina = true">
          <v-list-item-icon><v-icon color="red">mdi-delete</v-icon></v-list-item-icon>
          <v-list-item-title>Elimina</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- Stesso dialog usato da /ordini: il conteggio vive sull'ordine, non
         sulla consegna, quindi non c'è nulla da duplicare qui. Si carica da
         solo nella sua open() a partire dall'ordine. -->
    <DettaglioConteggio v-if="conteggiato" ref="conteggio" :ordine="ordine" />

    <!-- Eliminare una consegna butta via le quantità distribuite: si conferma -->
    <v-dialog v-model="conferma_elimina" width="480">
      <v-card>
        <v-card-title class="red--text text-subtitle-1">
          Elimina consegna del {{ giorno }}
        </v-card-title>
        <v-card-text>
          Le quantità distribuite su questa consegna verranno perse.
          Il totale prenotato resta invariato.
          <div v-if="consegna.id_ordine_creato" class="mt-3 red--text">
            <v-icon small color="red" class="mr-1">mdi-alert</v-icon>
            Da questa consegna è già stato creato un ordine.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="grey" @click="conferma_elimina = false">Annulla</v-btn>
          <v-btn outlined color="red" :loading="in_corso === 'elimina'" @click="elimina">
            Elimina
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="avviso" color="red" text outlined top timeout="3000">
      <v-icon color="red" class="mr-2">mdi-alert</v-icon>{{ messaggio }}
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import printer from "@/service/printer";
import DettaglioConteggio from "@/components/Conteggi/desktop/dettaglio_conteggio/conteggio_dettaglio";

/**
 * Testata di colonna di una consegna: data, carrelli, stato ordine, e il menu
 * delle azioni.
 *
 * La creazione dell'ordine e' lo snodo del flusso: da li' la consegna entra
 * in /consegne per la pianificazione e viene conteggiata dall'app esterna
 * che lavora sugli ordini. Il conteggio crisantemi interno e' dismesso,
 * quindi lo stato di conteggio si legge da `ordine.conteggiato`.
 *
 * Stampa, riempi rimanenza e crea ordine fanno rileggere la prenotazione al
 * server, quindi passano dalle azioni dello store che svuotano prima il buffer
 * di scrittura. Senza, lavorerebbero su un dato più vecchio di quello a video.
 */
export default {
  components: { DettaglioConteggio },

  props: {
    idPrenotazione: { type: String, required: true },
    consegna: { type: Object, required: true },
  },

  data() {
    return {
      menu: false,
      conferma_elimina: false,
      in_corso: null,
      avviso: false,
      messaggio: "",
    };
  },

  computed: {
    occupato() {
      return this.in_corso !== null;
    },

    giorno() {
      return this.consegna.ts_data
        ? moment.unix(this.consegna.ts_data).format("DD/MM")
        : "—";
    },

    data_iso() {
      return this.consegna.ts_data
        ? moment.unix(this.consegna.ts_data).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");
    },

    cc() {
      return this.$store.getters["crisantemi/cc"]({
        id_prenotazione: this.idPrenotazione,
        id_consegna: this.consegna.id,
      }).toFixed(1);
    },

    ordine() {
      if (!this.consegna.id_ordine_creato) return null;
      return this.$store.getters.get_ordine_by_id(this.consegna.id_ordine_creato);
    },

    numero_ordine() {
      return this.ordine ? this.ordine.numero : null;
    },

    /** Flag dell'ordine, non del conteggio crisantemi che e' dismesso. */
    conteggiato() {
      return !!(this.ordine && this.ordine.conteggiato);
    },
  },

  methods: {
    async esegui(nome, azione, errore) {
      this.in_corso = nome;
      try {
        await azione();
        this.menu = false;
      } catch {
        this.messaggio = errore;
        this.avviso = true;
      } finally {
        this.in_corso = null;
      }
    },

    apri_conteggio() {
      this.menu = false;
      this.$nextTick(() => this.$refs.conteggio.open());
    },

    cambia_data(iso) {
      this.esegui(
        "data",
        () =>
          this.$store.dispatch("crisantemi/cambia_data_consegna", {
            id_prenotazione: this.idPrenotazione,
            id_consegna: this.consegna.id,
            ts: moment(iso).format("X"),
          }),
        "Non è stato possibile cambiare la data."
      );
    },

    stampa() {
      this.esegui(
        "stampa",
        async () => {
          // Il PDF è generato dal server: prima gli mandiamo le celle in coda.
          await this.$store.dispatch("crisantemi/flush");
          printer.print_pdf_consegna_crisantemi({
            id_prenotazione: this.idPrenotazione,
            id_consegna: this.consegna.id,
          });
        },
        "Salvataggio non riuscito: la stampa è stata annullata."
      );
    },

    riempi_rimanenza() {
      this.esegui(
        "rimanenza",
        () =>
          this.$store.dispatch("crisantemi/riempi_rimanenza", {
            id_prenotazione: this.idPrenotazione,
            id_consegna: this.consegna.id,
          }),
        "Non è stato possibile riempire la rimanenza."
      );
    },

    crea_ordine() {
      this.esegui(
        "ordine",
        async () => {
          const ordine = await this.$store.dispatch(
            "crisantemi/crea_ordine_da_consegna",
            {
              id_prenotazione: this.idPrenotazione,
              id_consegna: this.consegna.id,
            }
          );
          this.$emit("ordine-creato", ordine);
        },
        "Creazione ordine non riuscita: potrebbe esistere già."
      );
    },

    elimina() {
      this.esegui(
        "elimina",
        async () => {
          await this.$store.dispatch("crisantemi/elimina_consegna", {
            id_prenotazione: this.idPrenotazione,
            id_consegna: this.consegna.id,
          });
          this.conferma_elimina = false;
        },
        "Non è stato possibile eliminare la consegna."
      );
    },
  },
};
</script>

<style scoped>
.testata {
  cursor: pointer;
  line-height: 1.3;
  text-align: right;
}
.testata:hover {
  opacity: 0.75;
}
</style>
